import type { InjectionKey, Ref } from 'vue'
import type { Marker, ScoreLevel } from '@/shared/graphql/router/graphql'

export type TimelineMatchType =
  | 'Audio'
  | 'Video'
  | 'Transcript'
  | 'Text'
  | 'Image'

export interface TimelineRange {
  start: number
  end: number
}

export interface TimelineMatch {
  id: string
  type: TimelineMatchType
  level: ScoreLevel
  title: string
  score: number
  number: number
  location?: string
  markers?: Array<Marker | null>
  registered: TimelineRange
  infringing: TimelineRange
}

export interface TimelineSideMatch {
  id: string
  start: number
  end: number
  level: ScoreLevel
  match: TimelineMatch
}

export interface TimelineAnchor {
  x: number
  top: number
  bottom: number
}

export interface TimelineHoverState {
  hoveredId: Ref<string | null>
  hoveredMatch: Ref<TimelineMatch | null>
  hoveredAnchor: Ref<TimelineAnchor | null>
  enter: (match: TimelineMatch, anchor: TimelineAnchor) => void
  hide: () => void
}

export const TimelineHoverKey: InjectionKey<TimelineHoverState> =
  Symbol('TimelineHoverState')
